module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/wifi-6-e7bd2226680c7f751fa94791d87ec35d.webp";